import { ReactComponent as ArrowRightIconSvg } from "../../icons/arrow.right.svg";

export default function ArrowRightIcon({...props}){
  return(
    <ArrowRightIconSvg width={"20px"} height={"20px"} {...props}/>
  )
}

